const setSlideOptions = (state, slideOptions) => {
  state.slideOptions = slideOptions
}

export default {
  setSlideOptions,
}
